import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<string, { disabled: boolean }>(
  {
    fab: {
      cursor: 'pointer',
    },
    icon: {
      display: 'inline-block',

      '& > svg > path': {
        fill: 'currentColor',
      },
    },
    control: {
      display: 'none',
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: -1,
      opacity: 0,
    },
  },
  {
    name: 'upload-button',
  },
);

export default useStyles;
